"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_PROPERTIES = void 0;
exports.VALID_PROPERTIES = [
    'taxType',
    'taxCodeId',
    'tagGroup',
    'status',
    'seen',
    'reviewStatus',
    'receipts',
    'projectId',
    'performed',
    'original',
    'note',
    'mileageReport',
    'merchantName',
    'merchantAddress',
    'hidden',
    'externalAccountId',
    'departmentId',
    'currency',
    'categoryId',
    'bill.value',
    'amount',
    'accountNumber',
    'accountId',
    '',
];
//# sourceMappingURL=expense-activitylog.js.map